import React, { type MouseEvent, useCallback } from "react";
import { FormattedMessage } from "react-intl";
import { ForgetPasswordPopup } from "src/authentication/components/ForgetPasswordPopup";
import usePopup from "src/shared/hooks/popups/usePopup";

export const ForgetPasswordLink = () => {
  const { openPopup, renderPopup } = usePopup();
  const handleForgetPassword = useCallback(
    async (event: MouseEvent): Promise<void> => {
      event.preventDefault();
      try {
        await openPopup();
      } catch (ex) {
        return;
      }
    },
    [openPopup],
  );
  return (
    <>
      <FormattedMessage
        id="authentication.forget"
        values={{
          password: (
            <a href="" onClick={handleForgetPassword}>
              <FormattedMessage id="authentication.forget.password" />
            </a>
          ),
        }}
      />
      {renderPopup((popupProps) => (
        <ForgetPasswordPopup {...popupProps} />
      ))}
    </>
  );
};
